// features/notifications/panels/NotificationFiltersPanel.tsx — right-rail scope filters.

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Panel, SectionLabel } from '@/ui';
import { SCOPES } from '../meta';
import type { ScopeId } from '../filterNotifications';

export interface NotificationFiltersPanelProps {
  scope: ScopeId;
  onScopeChange: (scope: ScopeId) => void;
}

const Option = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 0;
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textPrimary};
`;

const SettingsLink = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.brandFrom};
  text-decoration: none;
`;

export function NotificationFiltersPanel({ scope, onScopeChange }: NotificationFiltersPanelProps) {
  return (
    <Panel>
      <SectionLabel as="h2">Notification Filters</SectionLabel>
      <div role="radiogroup" aria-label="Notification scope">
        {SCOPES.map((s) => (
          <Option key={s.id}>
            <input
              type="radio"
              name="notif-scope"
              value={s.id}
              checked={scope === s.id}
              onChange={() => onScopeChange(s.id)}
            />
            <span>{s.label}</span>
          </Option>
        ))}
      </div>
      <SettingsLink to="/settings">Settings</SettingsLink>
    </Panel>
  );
}
